import React, {
  createRef,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react'
import FileActions from './FileActions'
import LinkWithStatus from '../common/LinkWithStatus'
import { getRequest } from '../../services/base'
import { useParams } from 'react-router-dom'
import { NavContext } from '../../context/global_context'
import DownloadInlines from '../vehicle/inline_connections/DownloadInlines'
import { downloadFileBlob } from '../../utils/common'

const FilesForm = ({}) => {
  const interval = useRef(null)
  const formRef = createRef()
  const [value, dispatch] = useContext(NavContext)
  const [importFiles, setImportFiles] = useState([])

  let { vehicle } = useParams()

  useEffect(() => {
    getImportFile()
  }, [])

  const closeInterval = () => {
    if (interval.current) {
      clearInterval(interval.current)
    }
  }

  const callFunctionInterval = () => {
    interval.current = setInterval(() => {
      getImportFile()
    }, 15000)
  }

  const getImportFile = async () => {
    let res = await getRequest(
      `/api/importer/import_types/?vehicle_id=${vehicle}`
    )
    setImportFiles(res.data.data)
    dispatch({
      type: 'header',
      data: {
        header: res.data.vehicle_data.name,
        sub_header: 'Importers',
        id: res.data.vehicle_data.id,
        show_back_btn: true,
        make_model_id: res.data.vehicle_data.make_model_id,
      },
    })
    if (res.data.is_upload_going_on) {
      if (!interval.current) {
        callFunctionInterval()
      }
    } else {
      closeInterval()
    }
  }

  const downloadDTCMemo = async () => {
    let res = await getRequest(`/api/dtc_memos/export/${vehicle}/`, true, true)
    if (res?.msg) {
      dispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: res?.msg,
        },
      })
    } else {
      downloadFileBlob(res, `${vehicle}_dtc_memo.csv`)
      dispatch({
        type: 'notification',
        data: {
          notification_type: 'success',
          msg: 'File Download completed.',
        },
      })
    }
  }

  return (
    <div className="flex flex-col pt-6 flex-grow">
      <div className="flex flex-row bg-tracer-lt-blue rounded-t text-white px-3 text-sm font-light">
        <div className="w-full">Importer</div>
      </div>
      <div className="flex flex-row items-center justify-between h-16 bg-white w-full py-2 px-3 border-b border-gray-300">
        <div className="w-1/4">
          <div
            className="font-bold flex-none"
            onClick={() => {
              closeInterval()
            }}
          >
            dtc_memos.csv
          </div>
          <div className="text-sm" />
        </div>

        <LinkWithStatus
          onClickFunc={() => downloadDTCMemo()}
          href={''}
          className="cursor-pointer inline-block text-blue-500 underline mx-3"
          title="Download"
        />
      </div>
      <form
        action={`${process.env.REACT_APP_API_BASE_URL}/vehicles/${vehicle}/importers`}
        acceptCharset="UTF-8"
        method="post"
        encType="multipart/form-data"
        ref={formRef}
      >
        {importFiles.map((file, index) => (
          <div
            key={index}
            className="flex flex-row items-center h-16 bg-white w-full py-2 px-3 border-b border-gray-300"
          >
            <div className="w-1/4 flex items-center">
              <div
                className={`font-bold flex-none ${file.dependencies && 'text-gray-500'}`}
              >
                {file.file_name}
              </div>
            </div>

            <div className="flex-grow">
              <div
                className={`text-gray-500 text-sm text-center lg:text-left ${!file.dependencies && 'hidden'}`}
              >
                {file.dependencies}
              </div>
            </div>
            {file.file_name == 'inlines.csv' && (
              <div className="px-2">
                <DownloadInlines isButton={false} />
              </div>
            )}
            {!file.dependencies && (
              <FileActions
                fileId={file.file_name}
                filesList={file.versions}
                fileType={file.key}
                fileName={file.file_name}
                formRef={formRef}
                is_uploading={file.is_uploading}
                reloadData={() => {
                  getImportFile()
                }}
              />
            )}
          </div>
        ))}
      </form>
    </div>
  )
}

FilesForm.propTypes = {}

export default FilesForm
